// ---------------------------------------------------------------------------
// Dietary preferences / regimes
// ---------------------------------------------------------------------------
export const DIETS = ['vegetarian', 'vegan', 'gluten_free', 'lactose_free'];
/**
 * Where each diet's name is written, rather than the name itself.
 *
 * This file used to carry its own `{ fr, en }` pair per diet — a second copy
 * of `dietary.*`, which nothing read and which would have drifted the first
 * time a wording changed. The key points at the one place the wording lives.
 */
export const DIET_LABEL_KEYS = {
    vegetarian: 'dietary.vegetarian',
    vegan: 'dietary.vegan',
    gluten_free: 'dietary.glutenFree',
    lactose_free: 'dietary.lactoseFree',
};
//# sourceMappingURL=diets.js.map